const domify = require('domify');
const q = require('queried');
const ajax = require('component-ajax');

class ItemFeedLoader {
  constructor(model, container, feedUrl, callbacks) {
    this.model = model;
    this.container = container;
    this.callbacks = callbacks;
    this.feedUrl = feedUrl;
    this.feedItems = q('.infiniteFeed-items', this.container);
    this.header = q('.infiniteFeed-header', this.container);
    this.loadMoreButton = q('.load-more-button', this.container);
    this.itemSlug = window._metricsConfig.item.slug;
    this.locationSlug = window._metricsConfig.location.slug;
  }

  postProcessData(feed) {
    // exlude item itself from server feed array
    //
    // also, thats why server answer with 31 items (if we send request with "from_item" param)
    // so we must slice answer to 30 items anyway
    const clearedFeed = feed.filter(
      (feedItem) => !feedItem.includes(window._metricsConfig.item.slug),
    );
    if (feed.length != clearedFeed.length) { this.model.itemDroped = true; }

    return clearedFeed.slice(0, 30);
  }

  showLoadMore(hasMore) {
    if (hasMore && this.loadMoreButton) {
      this.loadMoreButton.removeAttribute('hidden');
    }
  }

  render() {
    this.feedItems.setAttribute('data-load-more', this.feedUrl);

    ajax({
      url: this.feedUrl,
      data: {
        from_item: true,
      },
      success: (data) => {
        if (data && data.feed) {
          const feed = this.postProcessData(data.feed);
          if (feed.length) {
            const rendered = domify(feed.join(''));
            this.header.removeAttribute('hidden');
            this.feedItems.appendChild(rendered);
            this.showLoadMore(data.has_more);

            // Replacement for the block is not all on the object page. Not of great importance
            if (window.kudago && window.kudago.isItemPage) {
              const container = document.querySelector('.infiniteFeed-container');
              if (container) {
                const hederEls = container.querySelectorAll('h2');
                hederEls.forEach((item) => {
                  const content = item.innerHTML;
                  const h3 = document.createElement('h3');
                  h3.classList.add(item.classList[0]);
                  h3.innerHTML = content;
                  item.replaceWith(h3);
                });
              }
            }

            if (this.callbacks) {
              this.callbacks.forEach((cb) => cb());
            }
          }
        }
      },
    });
  }
}

module.exports = ItemFeedLoader;
